import { arrayGroup } from "../utils/dataUtils";

/**
 * 将数组转换成看板列表数据
 * @param dataSource 数组
 * @param statueFiled 状态字段名
 * @returns 
 */
export function formatCardTableData(dataSource?: any[], statueFiled?: string): any[] {
  const newDataSource: any[] = [];
  if (Array.isArray(dataSource) && dataSource.length) {
    const groupData = arrayGroup(dataSource, statueFiled);
    newDataSource.push(groupData);
  }
  return newDataSource;
}